import { createContext } from 'react';
import { AbilityFactory, AppAbility } from '@open-commerce/oc-authorization-policies';

const defaultValue = AbilityFactory.instantiateAbilities([]);

export const AbilityContext = createContext<AppAbility>(defaultValue);
